// Components==============
import DragNDropTile from 'components/UI/DragNDropTile/DragNDropTile';
import InputField from 'components/UI/InputField/InputField';
import { SoundType } from 'components/UI/LetterBlock/LetterBlock';
import StatusBox, { BoxTypes } from 'components/UI/StatusBox/StatusBox';
import React, { useContext, useEffect, useState } from 'react';
import { compareArray } from 'utilities/compareArray';
import { convertArray } from 'utilities/convertArray';
import { convertString } from 'utilities/convertString';
import { SoundsExerciseContext } from '../../SoundsExercise';
import './Overview.module.scss';
// =========================

const Text = ({
    tiles,
    text,
    index,
}: {
    tiles: SoundType[];
    text: string;
    index: number;
}) => {
    const { words, useTiles, useInput } = useContext(SoundsExerciseContext);

    const [textBoxState, setTextBoxState] = useState<BoxTypes>('failed');
    const [tileBoxState, setTileBoxState] = useState<BoxTypes>('failed');
    const [textValue, setTextValue] = useState(text);

    const [tileBarState, setTileBarState] = useState(tiles);

    useEffect(() => {
        if (useInput) {
            if (convertString(words?.[index]?.name) === convertString(text))
                setTextBoxState('correct');
        }
        if (useTiles) {
            const mutatedArr = convertArray(tileBarState)?.filter(
                (tile) => tile !== ''
            );

            if (compareArray(mutatedArr, words?.[index]?.klanken))
                setTileBoxState('correct');
        }
    }, [words, text]);

    return (
        <div styleName="tile-text">
            {useTiles ? (
                <div styleName="tile-wrapper">
                    {tiles.map((tile, i) => {
                        const id = `${i} ${index}`;
                        return (
                            <DragNDropTile
                                key={id}
                                index={i}
                                id={id}
                                droppableCondition={false}
                                tileBarState={tileBarState}
                                setTileBarState={setTileBarState}
                                tilePartIsFinished
                            />
                        );
                    })}
                    <StatusBox boxState={tileBoxState} disableGridPlacement />
                </div>
            ) : null}
            <div styleName="text-wrapper">
                <InputField
                    boxState={textBoxState}
                    setBoxState={setTextBoxState}
                    handleSubmit={() => {}}
                    readOnly
                    value={useInput ? textValue : words?.[index]?.name}
                    setValue={setTextValue}
                />
            </div>
        </div>
    );
};

export default function Overview() {
    const { userAnswers } = useContext(SoundsExerciseContext);

    return (
        <div styleName="wrapper">
            {userAnswers.map((answer, index) => (
                <Text
                    key={index}
                    tiles={
                        answer.bars?.map((bar) =>
                            bar === null ? '' : bar
                        ) as SoundType[]
                    }
                    text={answer.text as string}
                    index={index}
                />
            ))}
        </div>
    );
}
